import { forwardRef } from "react";

import { Checkbox } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormCheckboxProps } from "../../types";

export const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Checkbox ref={ref} name={name} {...props} />
  </FormField>
));

FormCheckbox.displayName = "Form.Checkbox";
